import React from 'react';
import Form from './Form';

const FormContainer = props => <Form {...props} />;

export default FormContainer;
